// extracted by mini-css-extract-plugin
module.exports = {"default":"SuperButton_default__3fPon","red":"SuperButton_red__VdRRO"};